var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45 11.4553L0 6.0053L5.45 0.555297L6.86 1.9653L3.83 5.0053L21.6226 4.99473L18.5926 1.95473L20.0026 0.544727L25.4526 5.99473L20.0026 11.4447L18.5926 10.0347L21.6226 6.99473L3.83 7.0053L6.86 10.0453L5.45 11.4553Z",
    fill: "#537089"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSide);
export default __webpack_public_path__ + "static/media/arrow-side.c5cc4675a973fab7b54d430a529b4015.svg";
export { ForwardRef as ReactComponent };